import * as React from 'react';

import FolderUpload32 from './FolderUpload32';

export const folderUpload32 = () => <FolderUpload32 />;

export default {
    title: 'Icon/Content/FolderUpload32',
    component: FolderUpload32,
    parameters: {
        notes: "`import FolderUpload32 from 'box-ui-elements/es/icon/content/FolderUpload32';`",
    },
};
